import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

const LedgerSection = (props, context) => {
  return (
    <Row className="bigger-margin-top justify-content-around align-items-center ledger-section">
      <div className="text-center mb-md-0 mb-lg-4">
        <h2 className="text-center h1">
          {context.t("Securely start your crypto journey")}
        </h2>
        <p className="text-center fs-5 pt-4 text-lg-prewrap">
          {context.t(
            "Secure, grow your crypto and manage your NFTs \n with the new Bluetooth-enabled hardware wallet from Ledger."
          )}
        </p>
      </div>
      <Col xs={{ size: 12, order: 2 }} lg={{ size: 6, order: 1 }}>
        <div className="d-flex flex-column justify-content-between">
          <p className="px-2">
            {context.t(
              "Every journey in web3 should start with a Ledger. Together with our partner Ledger we enable you something epic."
            )}
          </p>
          <p className="px-2">
            {context.t(
              "Experience first-class NFT and crypto security with the Samsung x Ledger Web3 Starter Bundle and get an exclusive Samsung MX1 GENESIS NFT."
            )}
          </p>
          <p className="px-2">
            {context.t(
              "Secure your valuable digital assets with the Ledger Nano X hardware wallet. Manage and grow them, always with the Ledger Live app. It’s simple to get started."
            )}
          </p>
          <div className="px-2 mb-3">
            <div
              onClick={() => {
                const element = document.getElementById("faq-bundle");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              dangerouslySetInnerHTML={{
                __html: context.t(
                  "For information on how to get your ledger from the Web3 Starter Bundle and what other benefits come with it see <span class='pointer-url'>here</span>."
                ),
              }}
            />
          </div>
        </div>
      </Col>
      <Col
        xs={{ size: 12, order: 1 }}
        lg={{ size: 6, order: 2 }}
        className="py-lg-5 py-md-0 text-center text-md-end"
      >
        <img
          src={(REACT_APP_CDN_PATH || "") + "/Ledger_Nano_x.png"}
          alt="samsung"
          className="align-self-end ledger-img"
        />
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
LedgerSection.contextTypes = {
  t: PropTypes.func,
};

LedgerSection.propTypes = {};

LedgerSection.defaultProps = {};

export default LedgerSection;
